import { Navigate } from "react-router-dom";

/** Legacy onboarding path — redirects to the unified new-property wizard. */
const CreateWorkspace = () => <Navigate to="/properties/new" replace />;

export default CreateWorkspace;
